
<template>
  <v-card class="d-flex align-content-start flex-wrap ma-1" width="350" min-height="195" outlined @click="onBeerClick">

    <v-list-item three-line>
      <v-list-item-content>
        <div class="overline mb-1">{{brewery}}</div>
        <v-list-item-title class="headline mb-1 text-wrap">{{title}}</v-list-item-title>
        <v-list-item-subtitle>

        <template v-for="style in styles">
            <v-chip class="mr-1" color="primary" outlined x-small :key="style.styleId" >
              {{style.title}}
              </v-chip>
        </template>

        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-avatar tile size="80">
         <v-img :src="imageUrl" alt="image" contain></v-img>
      </v-list-item-avatar>
    </v-list-item>

    <v-card-actions >
        <template v-if="collectionType === 'none'">
          <template v-for="(collection, index) in collectionMerged">
            <v-btn :color="collection.amount > 0 ? 'primary' : ''" icon :key="index" @click="onAddToCollection(collection)" @click.stop>
                <v-badge :value="collection.amount > 0 && collection.type === 'Multi'" color="primary" :content="collection.amount" overlap>
                  <v-icon v-text="collection.icon"></v-icon>
                </v-badge>
            </v-btn>
          </template>
        </template>

      <template v-if="collectionType === 'Multi'">
        <v-btn fab small outlined color="primary" @click="onChangeAmount()" @click.stop>
         <h3>{{amount}}</h3>
        </v-btn>
      </template>

      <template v-if="collectionType === 'Single' || collectionType === 'Multi'">
        <v-btn fab small color="primary" icon @click="$emit('removed')" @click.stop>
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>

      <v-btn icon >
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>

    </v-card-actions>

    <v-snackbar v-model="alertShow" top color="red">
      {{alertMessage}}
    <v-btn color="white" outlined x-small @click.native="alertShow = false">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    </v-snackbar>

    <v-dialog v-model="dialogAmount" persistent max-width="250px">
      <v-card>

        <v-card-title>
          <span class="headline">Amount?</span>
        </v-card-title>

        <v-card-text>
          <v-form>
              <v-btn-toggle v-model="amountToSet" color="primary" >
              <v-btn value=1 color="white">1</v-btn>
              <v-btn value=2 color="white">2</v-btn>
              <v-btn value=3 color="white">3</v-btn>
              <v-btn value=4 color="white">4</v-btn>
            </v-btn-toggle>
            <v-btn-toggle v-model="amountToSet" color="primary" >
              <v-btn value=6 color="white">6</v-btn>
              <v-btn value=8 color="white">8</v-btn>
              <v-btn value=12 color="white">12</v-btn>
              <v-btn value=24 color="white">24</v-btn>
            </v-btn-toggle>
            <v-btn-toggle v-model="amountToSet" color="primary" >
              <v-btn value=5 color="white">5</v-btn>
              <v-btn value=10 color="white">10</v-btn>
              <v-btn value=15 color="white">15</v-btn>
              <v-btn value=20 color="white">20</v-btn>
            </v-btn-toggle>
            <v-text-field v-model.number="amountToSet" append-outer-icon="mdi-plus" prepend-icon="mdi-minus" @click:append-outer="amountToSet++" @click:prepend="amountToSet--"></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="onDialogAmountCancel">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="onDialogAmountOk">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>

</template>


<script>
export default {
  name: 'Beer',
  props: {
    beerId: Number,
    title: String,
    brewery: String,
    styles: Array,
    imageUrl: String,
    collectionData: Object,
    collectionId: Number,
    collectionType: String,
    amount: Number, // used in collections
  },
  data: () => ({
    alertShow: false,
    alertMessage: '',
    dialogAmount: false,
    amountToSet: 1,
    collectionItemToChange: null,
    collectionMerged: {},
  }),
  beforeMount() {
    // merge global collection with beer collection data
    this.collectionMerged = this.mergeCollection();
  },
  methods: {
    onBeerClick() {
      this.$emit('open', this.beerId);
    },
    onAddToCollection(collection) {
      this.collectionItemToChange = collection;
      if (collection.type === 'Multi') {
        this.amountToSet = collection.amount;
        this.dialogAmount = true;
      } else {
        if (collection.amount > 0) {
          this.amountToSet = 0;
        } else {
          this.amountToSet = 1;
        }

        this.changeCollection(this.collectionItemToChange.Id);
      }
    },
    onDialogAmountOk() {
      this.dialogAmount = false;

      if (this.collectionType === 'none') { // from home
        this.changeCollection(this.collectionItemToChange.Id);
      }

      if (this.collectionType === 'Multi') { // fromp multi collection need to change amount
        this.changeCollection(this.collectionId);
      }
    },
    onDialogAmountCancel() {
      this.dialogAmount = false;
      this.collectionItemToChange = null;
    },
    changeCollection(collectionId) {
      // add single
      const data = {
        amount: this.amountToSet,
        beerId: this.beerId,
        collectionId,
      };

      this.$webConn.request('app2_change_collection', data).then((result) => {
        if (this.collectionItemToChange) {
          this.collectionItemToChange.amount = result.amount;
        } else {
          // pass amount to parent, cant change propery directly vue warn
          this.$emit('update-amount', result.amount);
        }
      }).catch((error) => {
        this.alertMessage = error.Message;
        this.alertShow = true;
      });
    },
    onChangeAmount() {
      this.amountToSet = this.amount;
      this.dialogAmount = true;
    },
    mergeCollection() {
      // we need to merge out collection data and add color and amount fields to it
      // need to use object, array with uneven index doesn't seem to work properly
      const Merged = {};
      if (this.collectionData != null) {
        Object.entries(this.$store.state.collections).forEach(([key, val]) => {
          const newItem = { ...val };

          if (this.collectionData[key]) {
            newItem.amount = this.collectionData[key].amount;
          } else {
            newItem.amount = 0;
          }
          Merged[key] = newItem;
          // Merged.push(newItem);
        });
      } else {
        // no collection data just amount
        Object.entries(this.$store.state.collections).forEach(([key, val]) => {
          const newItem = { ...val };
          newItem.amount = 0;
          Merged[key] = newItem;
        });
      }
      return Merged;
    },
  },
  computed: {
  },
};
</script>
